import React, { FunctionComponent } from "react";
import LoadingOverlay from "../shared/loading_overlay";

const LoadingOverlaySuspense: FunctionComponent = () => {
  return <div className="LoadingOverlay-suspenseWrapper"><LoadingOverlay/></div>;
}

export default LoadingOverlaySuspense;
